<mat-chip-set class="celum-chip-set">
  <ng-content select="prefix"></ng-content>
  <ng-content></ng-content>
  @if (showClearAll) {
    <button class="celum-chip-set_clear-all" data-test-clear-all-button type="button" (click)="clearAllClicked.emit(true)">
      {{ clearAllButtonText | translate }}
    </button>
  }
</mat-chip-set>
